"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import Icon from "@/components/ui/AppIcon";

export default function ThemeSwitcher() {
  const { theme, setTheme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse" />
    );
  }

  const currentTheme = theme === "system" ? systemTheme : theme;

  const cycleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };

  return (
    <button
      onClick={cycleTheme}
      className="relative w-10 h-10 rounded-full bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 flex items-center justify-center group overflow-hidden"
      aria-label={`Switch theme (current: ${theme})`}
      title={`Current: ${theme === "system" ? `System (${systemTheme})` : theme}`}
    >
      {/* Background gradient on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-400/20 to-navy-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Icon */}
      <div className="relative z-10 transition-transform duration-300 group-hover:rotate-12">
        {currentTheme === "dark" ? (
          <Icon name="MoonIcon" size={20} variant="solid" className="text-amber-400" />
        ) : (
          <Icon name="SunIcon" size={20} variant="solid" className="text-amber-500" />
        )}
      </div>
      
      {/* System indicator */}
      {theme === "system" && (
        <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-navy-600 dark:bg-amber-500 border-2 border-white dark:border-gray-800" />
      )}
    </button>
  );
}